import { defineMessages } from 'react-intl';

const scope = 'cb.screens.CouponApply';

export default defineMessages({
  waitingForAcceptanceTitle: {
    id: `${scope}.waitingForAcceptanceTitle`,
    defaultMessage: 'Congratulations! You have successfully redeemed this coupon.',
  },
  requestFailedTitle: {
    id: `${scope}.requestFailedTitle`,
    defaultMessage: 'Coupon is not reserved!!',
  },
  requestHasBeenSentMessage: {
    id: `${scope}.requestHasBeenSentMessage`,
    defaultMessage: 'Your request has been sent to the business.',
  },
  checkOutOthersMessage: {
    id: `${scope}.checkOutOthersMessage`,
    defaultMessage: 'Please, check out other opportunities',
  },
  goToUsedCouponsText: {
    id: `${scope}.goToUsedCouponsText`,
    defaultMessage: 'Continue Browsing',
  },
  continueBrowsingText: {
    id: `${scope}.continueBrowsingText`,
    defaultMessage: 'Continue Browsing',
  },
});